import { CAMERA_SELECTED_RGB_COLORS } from 'helpers/globals'
import toRadian from 'helpers/toRadian'
import { ANGLE } from './index'

const clearCanvas = (canvas, ctx) => {
  const width = canvas.clientWidth
  const height = canvas.clientHeight

  const ratio = window.devicePixelRatio
  canvas.width = width * ratio
  canvas.height = height * ratio

  ctx.scale(ratio, ratio)
  ctx.translate(0, height / 2)
  ctx.save()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.restore()
}

const drawText = (i, ctx, colors, distances) => {
  ctx.fillStyle = colors[i].slice(0, 7) === 'rgba(0,' ? '#ffffff' : '#000000'
  const width = distances[i] - (i !== 0 ? distances[i - 1] : 0)
  const center = (distances[i] + (i !== 0 ? distances[i - 1] : 0)) / 2
  let textWidth = ctx.measureText(`Zone ${i + 1}`).width

  if (textWidth > width / 2) {
    textWidth = ctx.measureText(i + 1).width
    if (textWidth > width / 3) {
      const mult = i % 2 === 1 ? -1 : 1
      ctx.beginPath()
      ctx.moveTo(center, 0)
      ctx.strokeStyle = '#000000'
      ctx.lineTo(center, 50 * mult)
      ctx.stroke()
      ctx.fillStyle = '#000000'
      ctx.fillText(i + 1, center - textWidth / 2, 70 * mult)
    } else {
      ctx.fillText(i + 1, center - textWidth / 2, 0)
    }
  } else {
    ctx.fillText(`Zone ${i + 1}`, center - textWidth / 2, 0)
  }
}

// helper method for drawing the canvas display for the analytic zones selector
export default function drawCanvas(rawDistances, override, colors, canvas, ctx) {
  const startAngle = toRadian(-ANGLE / 2)
  const endAngle = toRadian(ANGLE / 2)
  const distance = 1.075 * rawDistances[rawDistances.length - 1]
  const distances = rawDistances.map(d => (canvas.clientWidth - 5) * d / distance)

  clearCanvas(canvas, ctx)

  ctx.beginPath()
  ctx.moveTo(0, 0)
  ctx.arc(0, 0, canvas.clientWidth - 5, startAngle, endAngle)
  ctx.strokeStyle = `rgba(${CAMERA_SELECTED_RGB_COLORS.blue}, 0.80)`
  ctx.closePath()
  ctx.stroke()

  ctx.beginPath()
  ctx.font = '20px Arial'
  ctx.textBaseline = 'middle'
  ctx.moveTo(0, 0)
  ctx.arc(0, 0, distances[0], startAngle, endAngle)
  ctx.fillStyle = colors[0]
  ctx.fill()

  drawText(0, ctx, colors, distances)

  for (let i = 1; i < distances.length; i++) {
    ctx.beginPath()
    ctx.arc(0, 0, distances[i - 1], startAngle, endAngle)
    ctx.arc(0, 0, distances[i], endAngle, startAngle, true)
    ctx.fillStyle = colors[i]
    ctx.fill()
    drawText(i, ctx, colors, distances)
  }

  ctx.beginPath()
  ctx.arc(0, 0, distances[distances.length - 1], startAngle, endAngle)
  ctx.arc(0, 0, canvas.clientWidth - 5, endAngle, startAngle, true)
  ctx.fillStyle = colors[colors.length - 1]
  ctx.fill()
  ctx.fillStyle = colors[colors.length - 1].slice(0, 7) === 'rgba(0,' ? '#ffffff' : '#000000'
  ctx.fillText('4', (distances[distances.length - 1] + canvas.clientWidth - 5 - ctx.measureText(4).width) / 2, 0)
}



// WEBPACK FOOTER //
// ./src/components/AnalyticZonesSelector/drawCanvas.js